export default {
    TO_PERCENT_ACTION: 'to_percent',
    BY_PERCENT_ACTION: 'by_percent',
    TO_FIXED_ACTION: 'to_fixed',
    BY_FIXED_ACTION: 'by_fixed',
    CART_FIXED_ACTION: 'cart_fixed',
    BUY_X_GET_Y_ACTION: 'buy_x_get_y',
}



// WEBPACK FOOTER //
// ./src/view/constant/salesrule/SimpleActionConstant.js